export const colors = {
  avatarRandomColors: [
    '#f56a00',
    '#7265e6',
    '#ffbf00',
    '#00a2ae',
    '#FF5733',
    '#33FF57',
    '#3357FF',
    '#F1C40F',
    '#8E44AD',
    '#E67E22',
    '#2ECC71',
    '#3498DB'
  ]
};
